export const AnalyzeIdentifier = Object.freeze({
  ID: 'M' + Math.random().toString(36).slice(-6).toUpperCase(),
});
